// stores/loading.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLoadingStore = defineStore('loading', () => {
  const isLoading = ref(false);
  const requestCount = ref(0);
  let hideTimeout: number | null = null;
  let safetyTimeout: number | null = null;

  const HIDE_DELAY = 300;
  const SAFETY_LIMIT = 15000;

  const clearSafety = () => {
    if (safetyTimeout) {
      clearTimeout(safetyTimeout);
      safetyTimeout = null;
    }
  };

  const showLoading = () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    requestCount.value++;
    if (requestCount.value > 0) {
      isLoading.value = true;
      clearSafety();
      safetyTimeout = window.setTimeout(() => {
        console.warn('[loading] safety timeout, force reset (count was', requestCount.value, ')');
        requestCount.value = 0;
        isLoading.value = false;
        safetyTimeout = null;
      }, SAFETY_LIMIT);
    }
  };

  const hideLoading = () => {
    requestCount.value--;

    if (requestCount.value <= 0) {
      requestCount.value = 0;
      clearSafety();

      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }

      hideTimeout = window.setTimeout(() => {
        isLoading.value = false;
        hideTimeout = null;
      }, HIDE_DELAY);
    }
  };

  const resetLoading = () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
    clearSafety();
    requestCount.value = 0;
    isLoading.value = false;
  };

  return {
    isLoading,
    requestCount,
    showLoading,
    hideLoading,
    resetLoading,
  };
});
